'use client';

import React from 'react';
import { Radio } from 'lucide-react';

interface BreakingNewsTickerProps {
  items: string[];
  lang?: 'hi' | 'en';
}

export default function BreakingNewsTicker({ items, lang = 'hi' }: BreakingNewsTickerProps) {
  const tickerText = items.join('   •••   ');

  return (
    <div className="bg-primary flex items-stretch overflow-hidden">
      {/* Label */}
      <div className="flex items-center gap-1.5 px-3 py-2 bg-red-800 shrink-0 z-10">
        <Radio size={12} className="text-white animate-pulse" />
        <span className="text-white text-xs font-bold font-hindi tracking-wide whitespace-nowrap">
          {lang === 'hi' ? 'ब्रेकिंग' : 'BREAKING'}
        </span>
      </div>

      {/* Scrolling content */}
      <div className="flex-1 overflow-hidden relative flex items-center">
        <div className="ticker-animation whitespace-nowrap py-2 px-4">
          <span className="text-white text-xs font-hindi font-medium">
            {tickerText}
          </span>
        </div>
      </div>
    </div>
  );
}